import React from "react";
import { toastr } from "react-redux-toastr";
import { Document } from "react-pdf";
import VisibilitySensor from "react-visibility-sensor";
import { PDFDocumentProxy, PDFPageProxy } from "pdfjs-dist";

import { IBookInfo } from "../../../store/modules/library/IBookInfo";

import { DocumentLoading } from "./DocumentLoading";

import { ListItem } from "./ListItem";
import { getHeightFromView } from "./getHeightsFromView";

interface IProps {
  record: Pick<IBookInfo, "title" | "pdfDocumentPath">;
}

interface IState {
  pagesHeight: string[],
}

export class PDFViewer extends React.Component<IProps, IState> {
  private documentRef?: HTMLDivElement;

  readonly state = {
    pagesHeight: [],
  };

  constructor(readonly props: IProps) {
    super(props);

    this.onDocumentLoadSuccess = this.onDocumentLoadSuccess.bind(this);
    this.onDocumentLoadError = this.onDocumentLoadError.bind(this);
    this.setDocumentRef = this.setDocumentRef.bind(this);
  }

  private onDocumentLoadSuccess(pdf: PDFDocumentProxy) {
    const promises = Array.from({ length: pdf.numPages }, (k, v) => v + 1)
      .map(pageNumber => pdf.getPage(pageNumber));

    // @ts-ignore
    Promise.all(promises).then((pages: PDFPageProxy[]) => {
      this.setState({ pagesHeight: getHeightFromView(pages) });
    })
  }

  private onDocumentLoadError(error: Error) {
    const { record: { title } } = this.props;
    toastr.error(`${title}`, error.message);
  }

  private setDocumentRef(element: HTMLDivElement) {
    this.documentRef = element;
  };

  render() {
    const { record: { pdfDocumentPath } } = this.props;
    const { pagesHeight } = this.state;

    return pdfDocumentPath
      ? (
        <Document
          inputRef={this.setDocumentRef}
          file={pdfDocumentPath}
          onLoadSuccess={this.onDocumentLoadSuccess}
          onLoadError={this.onDocumentLoadError}
          loading={DocumentLoading}
        >
          {
            (this.documentRef && pagesHeight.length)
              ? (
                pagesHeight.map((height, index) => (
                  <VisibilitySensor
                    key={index}
                    containment={this.documentRef}
                    offset={{ top: 50, bottom: 50 }}
                    partialVisibility
                  >
                    {({ isVisible }) => (
                      <ListItem
                        index={index}
                        isVisible={isVisible}
                        height={height}
                      />
                    )}
                  </VisibilitySensor>
                ))
              )
              : DocumentLoading
          }
        </Document>
      )
      : DocumentLoading;
  }
}
